module.exports = __webpack_public_path__ + "img/tabard.21ad21ab.png";